export default "__VITE_ASSET__19cc57e2__"